import { Component, input, output } from '@angular/core';
import { Toast, ToastType } from './toast.model';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss'
})
export class ToastComponent {
    // Input signals
    readonly toast = input.required<Toast>();
    readonly isExiting = input<boolean>(false);

    // Output events
    readonly onClose = output<string>();

    /**
     * Get CSS class based on toast type
     */
    protected getTypeClass(): string {
        const typeClasses: Record<ToastType, string> = {
            success: 'toast--success',
            error: 'toast--error',
            warning: 'toast--warning',
            info: 'toast--info'
        };
        return typeClasses[this.toast().type];
    }

    /**
     * Handle close button click
     */
    protected close(): void {
        this.onClose.emit(this.toast().id);
    }
}
